import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';

@Component({
	selector: 'app-gift-card-balance-sheet',
	templateUrl: './gift-card-balance-sheet.component.html',
	styleUrls: ['../../../../../commandcenter.scss'],
})
export class GiftCardBalanceSheetComponent implements OnInit {
	balanceSheet: BalanceSheetObject;

	endDate: string;

	storeDetail: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.getBalanceSheet(this.app.moment().format('YYYY-MM-DD'));
	}

	async getBalanceSheet(endDate) {
		endDate = this.app.moment(endDate).format('YYYY-MM-DD');
		this.endDate = endDate;
		this.app.loading(true);
		const resp = await this.focuslink.giftCardBalanceSheet(this.venueService.subscriptionVenue.value.key, endDate);
		this.balanceSheet = resp;
		this.app.loading(false);
		return this.balanceSheet;
	}

	// exportToPdf(targetElementId: string, fileName) {
	// 	const element = document.getElementById(targetElementId	);
	// 	console.log(element);
	// 	this.app.generatePdfForDownload(element, fileName);
	// }
}

export interface BalanceSheetObject {
	venueKey: number;
	endDate: string;
	activations: number;
	increments: number;
	redemptions: number;
	adjustments: number;
	balance: number;
	activityByStore: BalanceSheetStoreActivity[];
}

export interface BalanceSheetStoreActivity {
	venueKey: string;
	storeId: number;
	venueName: string;
	activations: number;
	increments: number;
	redemptions: number;
	adjustments: number;
	balance: number;
}
